import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header";
import Popup from "./components/Popup/Popup";
import Sidebar from "./components/SideBar/Sidebar";
import Toast from "./components/Toast/Toast";
import Leader from "./pages/Leader/Leader";
import Login from "./pages/Login/Login";
import Payment from "./pages/Payment/Payment";
import UserDetail from "./pages/Users/sub/UserDetail";
import Users from "./pages/Users/Users";
import Step1 from "./pages/WriteProject/sub/Step1";
import Step2 from "./pages/WriteProject/sub/Step2";
import Step3 from "./pages/WriteProject/sub/Step3";
import Step4 from "./pages/WriteProject/sub/Step4";
import WriteProject from "./pages/WriteProject/WriteProject";
import Magazine from "./pages/Magazine/Magazine";
import Coupon from "./pages/Coupon/Coupon";
import Alliance from "./pages/Alliance/Alliance";
import AddList from "./pages/AddList/AddList";
import Newadd from "./pages/Newadd/Newadd";
import Policy from "./pages/Policy/Policy";
import Savelist from "./pages/Savelist/Savelist";
import Startlist from "./pages/Startlist/Startlist";
import FinishList from "./pages/FinishList/Finishlist";
import PaymentList from "./pages/PaymentList/PaymentList";
import PortFolioView from "./pages/PortFolioView/PortFolioView";
import Notice from "./pages/Notice/Notice";
import Step6 from "./pages/WriteProject/sub/Step6";
import Step5 from "./pages/WriteProject/sub/Step5";
import WriteMeetup from "./pages/WriteProject/WriteMeetup";
import MeetStep1 from "./pages/WriteProject/sub/MeetStep1";
import Certification from "./pages/Certification/Certification";
import Invitation from "./pages/Invitation/Invitation";
import WriteNotice from "./pages/WriteNotice/WriteNotice";
import AllianceInsertContainer from "./pages/AllianceInsert/container/AllianceInsertContainer";
import AllianceFixContainer from "./pages/AllianceFix/container/AllianceFixContainer";
import CertificationDetail from "./pages/CertificationDetail/CertificationDetail";
import AddFix from "./pages/AddFix/AddFix";
import LineAdd from "./pages/LineAdd/LineAdd";
import Report from "./pages/Report/Report";
import Loading from "./components/Loading/Loading";
import WriteCoupon from "./pages/WriteCoupon/WriteCoupon";
import CouponList from "./pages/CouponList/CouponList";
import ProjectUserList from "./pages/ProjectUserList/ProjectUserList";
import PaymentDetail from "./pages/PaymentDetail/PaymentDetail";
import FinishProjectList from "./pages/FinishProjectList/FinishProjectList";
import WriteMagazine from "./pages/WriteProject/WriteMagazine";
import MagazineStep1 from "./pages/WriteProject/sub/MagazineStep1";

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const Logout = useCallback(() => {
    window.sessionStorage.removeItem("accessToken");
    setIsLogin(false);
  }, []);

  useEffect(() => {
    const CheckToken = window.sessionStorage.getItem("accessToken");
    if (CheckToken) {
      setIsLogin(true);
    }
    return () => {};
  }, []);

  return (
    <BrowserRouter>
      <Header isLogin={isLogin} Logout={Logout} />
      {isLogin ? (
        <>
          <Routes>
            {/* 유저 목록 */}
            <Route path="/" element={<Users />} />
            {/* 유저 상세 */}
            <Route path="/user/detail" element={<UserDetail />} />
            {/* 리더 목록 */}
            <Route path="/leader" element={<Leader />} />
            {/* 프로젝트 등록 , 수정*/}
            <Route path="/prjt/write" element={<WriteProject />}>
              <Route path="step/1" element={<Step1 />} />
              <Route path="step/2" element={<Step2 />} />
              <Route path="step/3" element={<Step3 />} />
              <Route path="step/4" element={<Step4 />} />
              <Route path="step/5" element={<Step5 />} />
              <Route path="step/6" element={<Step6 />} />
            </Route>
            {/* 밋업 등록, 수정 */}
            <Route path="/mtup/write" element={<WriteMeetup />}>
              <Route path="step/1" element={<MeetStep1 />} />
              <Route path="step/2" element={<Step2 />} />
              <Route path="step/3" element={<Step5 />} />
              <Route path="step/4" element={<Step6 />} />
            </Route>
            {/* 매거진 만들기 */}
            <Route path="/magazine/write" element={<WriteMagazine />}>
              <Route path="step/1" element={<MagazineStep1 />} />
              <Route path="step/2" element={<Step6 />} />
            </Route>
            {/* 결제 목록 */}
            <Route path="/payment" element={<Payment />} />
            {/* 매거진 목록 */}
            <Route path="/magazine/list" element={<Magazine />} />
            {/* 광고 목록 */}
            <Route path="/add/list" element={<AddList />} />
            {/* 띠배너 등록 */}
            <Route path="/add/line/fix" element={<LineAdd />} />
            {/* 광고 만들기 */}
            <Route path="/add/new" element={<Newadd />} />
            {/* 광고 수정 */}
            <Route path="/add/fix" element={<AddFix />} />
            {/* 프로젝트 임시저장 */}
            <Route path="/prjt/extra" element={<Savelist />} />
            {/* 프로젝트 모집중 */}
            <Route path="/prjt/start" element={<Startlist />} />
            {/* 마감된 프로젝트 */}
            <Route path="/prjt/finish" element={<FinishList />} />
            {/* 밋업 임시저장 */}
            <Route path="/mtup/extra" element={<Savelist />} />
            {/* 밋업 모징중 */}
            <Route path="/mtup/start" element={<Startlist />} />
            {/* 마감된 밋업 */}
            <Route path="/mtup/finish" element={<FinishList />} />
            {/* 밋업 신청 리스트 */}
            <Route path="/mtup/list" element={<FinishProjectList />} />
            {/* 프로젝트 신청 리스트 */}
            <Route path="/prjt/list" element={<FinishProjectList />} />
            {/* 결제 리스트 */}
            <Route path="/payment/list" element={<PaymentList />} />
            {/* 결제 상세 */}
            <Route path="/payment/detail" element={<PaymentDetail />} />
            {/*신규 제휴 등록 */}
            <Route path="/alliance/new" element={<AllianceInsertContainer />} />
            {/* 제휴 수정  */}
            <Route path="/alliance/fix" element={<AllianceFixContainer />} />
            {/* 프로젝트 상세*/}
            <Route path="/prjt/user/list" element={<ProjectUserList />} />
            {/* 밋업 상세*/}
            <Route path="/mtup/user/list" element={<ProjectUserList />} />
            {/* 사용자 포트폴리오 보기 */}
            <Route path="/portfolio/view" element={<PortFolioView />} />
            {/* 쿠폰 리스트 */}
            <Route path="/etc/coupon" element={<Coupon />} />
            {/* 쿠폰 발급대상 */}
            <Route path="/etc/coupon/list" element={<CouponList />} />
            {/* 쿠폰 추가 */}
            <Route path="/insert/coupon" element={<WriteCoupon />} />
            {/* 인비테이션 추가 */}
            <Route path="/insert/invitation" element={<Invitation />} />
            {/* 제휴 관리 */}
            <Route path="/etc/alliance" element={<Alliance />} />
            {/* 약관 관리 */}
            <Route path="/etc/policy" element={<Policy />} />
            {/* 공지 관리 */}
            <Route path="/etc/notice" element={<Notice />} />
            {/* 공지 작성 */}
            <Route path="/new/notice" element={<WriteNotice />} />
            {/* 인증서 관리 */}
            <Route path="/etc/certification" element={<Certification />} />
            {/* 인증서 관리 */}
            <Route
              path="/etc/certification/detail"
              element={<CertificationDetail />}
            />
            {/* 신고 관리 */}
            <Route path="/report" element={<Report />} />
          </Routes>
          <Sidebar />
          <Popup />
        </>
      ) : (
        <Routes>
          <Route path="/" element={<Login setIsLogin={setIsLogin} />} />
        </Routes>
      )}
      <Toast />
      <Loading />
    </BrowserRouter>
  );
}

export default App;
